import { defineMessages } from 'react-intl';

export const messages: {
	carouselHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prevButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	carouselCompleteMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	completeCtaButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissalFlagHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissalFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissalFlagLinkText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	carouselHeading: {
		id: 'townsquare.twc-onboarding-widget.carousel.main-heading',
		defaultMessage: 'Get started',
		description:
			'Main heading for the get started widget for TWC onboarding, featured on the home page',
	},
	prevButtonLabel: {
		id: 'townsquare.twc-onboarding-widget.carousel.prev-button-label',
		defaultMessage: 'See previous cards',
		description:
			'Button label to show the previous cards in the getting started widget section, shown on the home page of TWC onboarding',
	},
	nextButtonLabel: {
		id: 'townsquare.twc-onboarding-widget.carousel.next-button-label',
		defaultMessage: 'See more cards',
		description:
			'Button label to show the next cards in the getting started widget section, shown on the home page of TWC onboarding',
	},
	closeButtonLabel: {
		id: 'townsquare.twc-onboarding-widget.carousel.close-button-label',
		defaultMessage: 'Dismiss section',
		description:
			'Button label to dismiss the whole getting started widget section, shown on the home page of TWC onboarding',
	},
	carouselCompleteMessage: {
		id: 'townsquare.twc-onboarding-widget.carousel.complete-message',
		defaultMessage: "You've completed all your onboarding tasks. Way to go, you!",
		description:
			'Text displayed when the user has completed all onboarding tasks, shown on the home page of TWC onboarding when carousel is complete',
	},
	completeCtaButtonLabel: {
		id: 'townsquare.twc-onboarding-widget.carousel.complete-cta-button-label',
		defaultMessage: 'Discover more apps',
		description:
			'Button label to discover more apps from Crossflow, shown on the home page of TWC onboarding when carousel is complete',
	},
	dismissButtonLabel: {
		id: 'townsquare.twc-onboarding-widget.carousel.dismiss-button-label',
		defaultMessage: 'Dismiss',
		description:
			'Button label to dismiss the onboarding carousel, shown on the home page of TWC onboarding when carousel is complete',
	},
	dismissalFlagHeading: {
		id: 'post-office.townsquare-onboarding-widget.dismissal-flag-heading',
		defaultMessage: 'Get started section dismissed',
		description:
			'Main heading for the flag that appears when the TWC onboarding section is dismissed',
	},
	dismissalFlagDescription: {
		id: 'post-office.townsquare-onboarding-widget.dismissal-flag-description',
		defaultMessage:
			'You can always find tips and guidance for your new apps in our blog and support documentation.',
		description:
			'Description for the flag that appears when the TWC onboarding section is dismissed',
	},
	dismissalFlagLinkText: {
		id: 'post-office.townsquare-onboarding-widget.dismissal-flag-link-text',
		defaultMessage: 'More on apps and features',
		description:
			'Main heading for the getting started widget for TWC onboarding, featured on the home page',
	},
});
